<template>
    <div class="success-page d-flex flex-column min-vh-100">
      <div class="container flex-grow-1 d-flex justify-content-center align-items-center">
        <div class="col-md-6 col-lg-5">
          <div class="card card-custom border-0 text-center">
            <div class="card-body p-5">
              <img src="../../../public/assets/reset-password.png" alt="Success" class="mb-4" width="80" />
              <h3 class="fw-bold mb-2">Your password has been changed</h3>
              <p class="text-muted mb-4">Now you can login with your new password</p>
              <button @click="goToLogin" class="btn btn-success btn-lg w-100">
                Go to Login Page
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer text-center py-3">
        <small class="text-muted">
          © PT Anugrah Multi Remittance 2025 |
          <a href="#" class="text-decoration-none text-muted">Term & Conditions</a> |
          <a href="#" class="text-decoration-none text-muted">Privacy Policy</a>
        </small>
      </footer>
    </div>
  </template>

  <script>
import { onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';

  export default {
    methods: {
      goToLogin() {
        this.$router.push({ name: "Signin" });
      },
    },
    setup() {
    const store = useStore();
    const body = document.getElementsByTagName("body")[0];

    onBeforeMount(() => {
      store.state.hideConfigButton = true;
      store.state.showNavbar = false;
      store.state.showSidenav = false;
      store.state.showFooter = false;
      body.classList.remove("bg-gray-100");
    });

    onBeforeUnmount(() => {
      store.state.hideConfigButton = false;
      store.state.showNavbar = true;
      store.state.showSidenav = true;
      store.state.showFooter = true;
      body.classList.add("bg-gray-100");
    });
  },
  };
  </script>

  <style scoped>
  .success-page {
    background-color: #F4F6F6;
  }

  .card {
    border-radius: 0.5rem;
  }

  .btn-success {
    background: linear-gradient(90deg, #37a269 0%, #2eb76c 100%);
    border: none;
  }
  </style>
